import { type StyleSheetTextType, type StyleSheetType } from "@client/types/StyleSheet";

export const getStyleSheetClassName = (type: StyleSheetType, id: string): string => `ss_${id}_${type}`;
export const getStyleSheetColorClassName = (type: StyleSheetTextType, id: string): string => `ss_color_${id}_${type}`;
export const getStyleSheetLinkClassName = (type: StyleSheetTextType, id: string): string => `ss_link_${id}_${type}`;
